import type {
    IRTCurrentCampaignData,
    IRTUpdateCampaignTableData,
} from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignTypes";
import { updateKeywordsFromCampaign } from "app/pages/digital-marketing/keywords-campaigns/reports/keywords-report/keywords-table/KeywordsCamapaignKeywordsReportTableUtils";
import { RankTrackerQueryType } from "app/pages/digital-marketing/keywords-campaigns/shared/constants";

import { useRankTrackerMutation } from "../useRankTrackerMutation";

type UseKeywordsMutationOptions = {
    campaignId: string;
    onSuccess?: () => void;
    onError?: (error: Error) => void;
};

export const useKeywordsMutation = ({ campaignId, onSuccess, onError }: UseKeywordsMutationOptions) => {
    return useRankTrackerMutation<IRTCurrentCampaignData, Error, IRTUpdateCampaignTableData>({
        campaignId,
        queryType: RankTrackerQueryType.KeywordsTable,
        mutationFn: (payload) => updateKeywordsFromCampaign(payload, campaignId),
        onSuccess,
        onError,
    });
};
